module.exports = __webpack_public_path__ + "static/media/p20n-cn-01.6f6c7c4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/p20n-cn-01.mp4
// module id = daqc
// module chunks = 1